var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnimicro = function SvgUnimicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-unimicro)",
    d: "m19.452 4.014-.003.006-.034.003v6.28q.13-.012.253-.02c5.37-.187 9.877 4.014 10.065 9.387s-4.014 9.873-9.384 10.061c-5.37.185-9.876-4.016-10.064-9.386-.102-2.466 1.745-1.47 6.365.182v-6.35c-10.37-3.97-12.897-1.412-12.626 6.38.308 8.83 7.716 15.737 16.544 15.429 8.829-.308 15.737-7.716 15.428-16.544-.308-8.829-7.715-15.737-16.544-15.428"
  })));
};
export default SvgUnimicro;